export default {
  loggedIn: {
    deposit: 'Deposit',
    withdraw: 'Tarik Dana',
    balance: 'Total Saldo',
    cash: 'Tunai',
    bonus: 'Bonus',
    withdrawable: 'Dapat Ditarik',
    transaction: 'Transaksi',
    history: 'Riwayat',
    myBet: 'My Bet',
    rollover: 'Rollover',
    vault: 'Brankas',
    notification: 'Notifikasi',
    affiliate: 'Afiliasi - Dapatkan $5.000 Per Bulan',
    affiliateTitle: 'Afiliasi',
    affiliateBadge: 'Dapatkan $5.000 Per Bulan',
    settings: 'Pengaturan',
    currency: 'Mata Uang',
    language: 'Bahasa',
    liveSupport: 'Dukungan Langsung',
    signOut: 'Keluar'
  }
};
